import { crudService } from '../../../services/api/crudService';
import type { Item, ItemInput } from '../types/materialTypes';

/** Materials and work rates share the /items endpoint (type: 'material' | 'service'). */
export const itemService = crudService<Item, ItemInput>('/items');

export const materialService = {
  ...itemService,
  lowStock: (limit = 5) => itemService.list({ type: 'material', lowStock: 'true', limit }),
};
